module.exports = __webpack_public_path__ + "img/service-video.5ea4bcaa.svg";